import { render } from "./HalfPanel.vue?vue&type=template&id=160e06b1&scoped=true"
import script from "./HalfPanel.vue?vue&type=script&lang=js"
export * from "./HalfPanel.vue?vue&type=script&lang=js"

import "./HalfPanel.vue?vue&type=style&index=0&id=160e06b1&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1700309314/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-160e06b1"]])

export default __exports__